import { render, staticRenderFns } from "./MoneyBoxNew.vue?vue&type=template&id=266384f7"
import script from "./MoneyBoxNew.vue?vue&type=script&lang=js"
export * from "./MoneyBoxNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports